/**
 * Format a CO₂ value (given in kg) using the most readable unit.
 * < 1 kg   → e.g. "0.4 kg CO₂e"
 * < 1 000 kg → e.g. "42 kg CO₂e"  or  "342 kg CO₂e"
 * ≥ 1 000 kg → e.g. "1.4 t CO₂e"
 */
export function formatCo2Kg(kg: number): string {
  if (kg < 1_000) {
    return `${kg.toLocaleString("en-GB", { maximumFractionDigits: 1 })} kg CO₂e`
  }
  return `${(kg / 1_000).toLocaleString("en-GB", { maximumFractionDigits: 1 })} t CO₂e`
}
